import type { ImageLoadData } from '@/map-phaser-new/interfaces'

export const mainMapImageLoadData: () => ImageLoadData[] = () => [
  {
    name: 'map',
    compressed: true,
    data: {
      astc: {
        type: 'KTX',
        textureURL: 'map/compressed/mapNew_v2_astc12.ktx',
      },
      etc: {
        type: 'KTX',
        textureURL: 'map/compressed/mapNew_v2_etc2rgba.ktx',
      },
      img: {
        textureURL: 'map/mapNew_v2.avif',
      },
      place: 'map/mapNew_v2.avif',
    },
  },
  {
    name: 'overlayimage',
    compressed: true,
    data: {
      astc: {
        type: 'KTX',
        textureURL: 'map/compressed/overlay_v2_astc12.ktx?v2',
      },
      etc: {
        type: 'KTX',
        textureURL: 'map/compressed/overlay_v2_etc2rgba.ktx',
      },
      img: {
        textureURL: 'map/overlay_v2.avif?v1',
      },
      place: 'map/overlay_v2.avif?v1',
    },
  },
  {
    name: 'building_new_label',
    compressed: false,
    data: {
      place: 'map/building_new_label.avif',
    },
  },
  {
    name: 'building_championship_bg',
    compressed: false,
    data: {
      place: 'map/building_championship_bg.avif',
    },
  },
  {
    name: 'lock',
    compressed: false,
    data: {
      place: 'icons/icon-lock-lg.avif',
    },
  },
  {
    name: 'blocked',
    compressed: false,
    data: {
      place: 'icons/icon-blocked.avif',
    },
  },
  {
    name: 'timerbar',
    compressed: false,
    data: {
      place: 'lab/timerbar.avif',
    },
  },
  {
    name: 'exclamationMarkNotification',
    compressed: false,
    data: {
      place: 'map/info_bubble.avif',
    },
  },
  {
    name: 'bubbleNotification',
    compressed: false,
    data: {
      place: 'map/bubble_notification.avif',
    },
  },
  {
    name: 'careerArrow',
    compressed: false,
    data: {
      place: 'map/career-map-arrow-yellow.avif',
    },
  },
  {
    name: 'link_account_image',
    compressed: false,
    data: {
      place: 'map/link-account-image.avif',
    },
  },
  {
    name: 'link_account_image_outline',
    compressed: false,
    data: {
      place: 'map/link-account-image-outline-v1.avif',
    },
  },
  {
    name: 'board_games_event_osra_image',
    compressed: false,
    data: {
      place: 'map/board-games-event-osra.avif',
    },
  },
  {
    name: 'board_games_event_osra_image_outline',
    compressed: false,
    data: {
      place: 'map/board-games-event-osra-outline.avif',
    },
  },
  {
    name: 'ice_and_fire_event_osra_image',
    compressed: false,
    data: {
      place: 'map/ice-and-fire-event-osra.avif',
    },
  },
  {
    name: 'ice_and_fire_event_osra_image_outline',
    compressed: false,
    data: {
      place: 'map/ice-and-fire-event-osra-outline.avif',
    },
  },
  {
    name: 'piggy_bank_osra_image',
    compressed: false,
    data: {
      place: 'map/piggy-bank-osra.avif',
    },
  },
  {
    name: 'piggy_bank_osra_image_outline',
    compressed: false,
    data: {
      place: 'map/piggy-bank-osra-outline.avif',
    },
  },
  {
    name: 'building_tooltip_top',
    compressed: false,
    data: {
      place: 'map/building_tooltip_top.avif',
    },
  },
  {
    name: 'building_tooltip_left',
    compressed: false,
    data: {
      place: 'map/building_tooltip_left.avif',
    },
  },
  {
    name: 'building_tooltip_right',
    compressed: false,
    data: {
      place: 'map/building_tooltip_right.avif',
    },
  },
  // {
  //   name: 'ibu_logo',
  //   compressed: false,
  //   data: {
  //     place: 'map/sponsor-circle-IBU.avif',
  //   },
  // },
]
